<div *ngIf="formGroup" [formGroup]="formGroup">
  <div>
    <label class="form-label" (mouseenter)="showNeutTooltip($event.target)" (mouseleave)="hideNeutTooltip()"
      data-tooltip-type="neut">
      <b>{{label }}:</b>
    </label>
    <input type="text" readonly placeholder="Kies" class="form-control" [ngClass]="neutSelectorSpecialClassName"
      id="neutDescription" formControlName="neutDescription" (click)="toggleCathegoryList()" />
    <div *ngIf="isCathegoryListOpen" class="custom-form-control">
      <ul class="cathegories-wrapper" [ngClass]="cathegoriesListSpecialClassName">
        <li *ngFor="let neutCathegory of neutenCathegories" (mouseenter)="activateNeutCathegory(neutCathegory)"
          (mouseleave)="resetActiveNeutCathegory()">
          <span>{{neutCathegory.description}}</span>
          <span class="arrow"><i class="fa fa-caret-right"></i></span>
          <ul *ngIf="activeNeutCathegory === neutCathegory" class="neut-list-wrapper">
            <li *ngFor="let neut of activeNeutCathegory.options" (click)="selectNeut(neut)">{{neut.omschrijving}}</li>
          </ul>
        </li>
      </ul>
    </div>
    <luv-validationError [show]="showError('neut')" [errorMessage]="errorMessage('neut')">
    </luv-validationError>
    <luv-validationError [show]="customNeutRemovalErrorMessage"
      [errorMessage]="customNeutRemovalErrorMessage"></luv-validationError>
  </div>

  <div *ngIf="isVoorsponningActive" class="voorsponning-wrapper">
    <div><label class="form-label"><b>Voorsponning:</b></label></div>
    <div class="row">
      <div class="left-voorsponning col-sm-6" *ngIf="!shouldHideLeftVoorsponning">
        <label *ngIf="!shouldHideRightVoorsponning" class="form-label">Links</label>
        <select class="form-select"
          [ngClass]="{'single': shouldHideRightVoorsponning, 'side-by-side': !shouldHideRightVoorsponning}"
          formControlName="linksVoorsponning" (change)="onLinksVoorsponningChanged()">
          <option value="0" [selected]="isBinnenDorpel || !input.model.linksVoorsponning">geen</option>
          <option *ngFor="let vo of leftVoorsponningOptions" [value]="vo"
            [selected]="getVorsponningValue(input.model.linksVoorsponning) == vo">{{vo}}mm</option>
        </select>
      </div>
      <div class="right-voorsponning col-sm-6" *ngIf="!shouldHideRightVoorsponning">
        <label *ngIf="!shouldHideLeftVoorsponning" class="form-label">Rechts</label>
        <select class="form-select"
          [ngClass]="{'single': shouldHideLeftVoorsponning, 'side-by-side': !shouldHideLeftVoorsponning}"
          formControlName="rechtsVoorsponning" (change)="onRechtsVoorsponningChanged()">
          <option value="0" [selected]="isBinnenDorpel || !input.model.rechtsVoorsponning">geen</option>
          <option *ngFor="let vo of rightVoorsponningOptions" [value]="vo"
            [selected]="getVorsponningValue(input.model.rechtsVoorsponning) == vo">{{vo}}mm</option>
        </select>
      </div>
    </div>
  </div>

  <div *ngIf="isSpecialNeut" class="custom-width-wrapper">
    <div class="row">
      <div class="col-sm-12">
        <label class="form-label"><b>Neutbreedte:</b></label>
        <input type="number" class="form-control" [value]="specialNeutWidth" (change)="onSpecialNeutCustomWidthChange($event)" integerOnly/>
      </div>
    </div>
  </div>
</div>